import { useEffect, useRef, useState } from 'react'

const useTabDetection = () => {
  const tabIdRef = useRef<string | null>(null)
  const [isLatestTab, setIsLatestTab] = useState(true)

  useEffect(() => {
    // Generate a unique identifier for this tab
    const tabId = `${Date.now().toString()}/game`
    tabIdRef.current = tabId

    // Store the tabId in localStorage
    localStorage.setItem('tabId', tabId)

    // Cleanup function to remove the tabId when the component unmounts
    return () => {
      localStorage.removeItem('tabId')
    }
  }, [])

  useEffect(() => {
    // Function to handle communication between tabs
    const handleStorageEvent = (event: StorageEvent) => {
      if (event.key === 'tabId') {
        // Check if the stored tabId matches the current tab's tabId
        if (event.newValue === tabIdRef.current) {
          // This tab is the latest one, update the stored tabId
          localStorage.setItem('tabId', tabIdRef.current || '')
          setIsLatestTab(true)
        } else {
          // Tab duplication detected on the "/game/:ids" route!
          setIsLatestTab(false)
        }
      }
    }

    // Listen for storage events from other tabs
    window.addEventListener('storage', handleStorageEvent)

    // Cleanup function to remove the storage event listener
    return () => {
      window.removeEventListener('storage', handleStorageEvent)
    }
  }, [])

  return { isLatestTab }
}

export default useTabDetection
